//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IconContext } from "react-icons";
import { BiBookBookmark } from "react-icons/bi";
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../descmoocsScreen.scss'

// @ADD Component types
interface IDescmoocsScreenLayoutProps {}

const DescmoocsScreenLayout: React.FC<IDescmoocsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <BannerTextPrimaryCommon text={"MOOCS"}/>
      <div className="container sobre-moocs">
      	<div className="title-sobre-moocs">
      		<span>SOBRE LOS MOOCS</span>
      	</div>
      	<div className="content-cards">
      		<div className="card-mooc-desc">
      			<IconContext.Provider value={{ color: "#FFFFFF", className: "icon" }}>
						  <div>
						    <BiBookBookmark/>
						  </div>
						</IconContext.Provider>
						<span className="text-desc-card">
							Cursos<br/> Gratuitos
						</span>
      		</div>
      		<div className="card-mooc-desc">
      			<IconContext.Provider value={{ color: "#FFFFFF", className: "icon" }}>
						  <div>
						    <BiBookBookmark/>
						  </div>
						</IconContext.Provider>
						<span className="text-desc-card">
							Material<br/> descargable
						</span>
      		</div>
      		<div className="card-mooc-desc">
      			<IconContext.Provider value={{ color: "#FFFFFF", className: "icon" }}>
						  <div>
						    <BiBookBookmark/>
						  </div>
						</IconContext.Provider>
						<span className="text-desc-card">
							Certificable
						</span>
      		</div>
      	</div>
      	<div className="text-desc-moocs-ab">
      		Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eu elit, enim habitant risus volutpat. Venenatis, hendrerit volutpat ornare iaculis. Ullamcorper egestas quis massa viverra cursus id metus in mi. Donec in arcu quis mi consectetur egestas. Mi vulputate at magna pellentesque morbi diam. Tellus velit ut aenean aliquet amet nullam amet tellus eget. Quam maecenas id pretium quis pellentesque. Et euismod iaculis erat in. Nunc in ullamcorper nulla vel, consectetur tristique purus.
					Arcu justo, risus dolor pretium egestas senectus laoreet pulvinar. Tortor elit fermentum non sed erat tincidunt et, mauris, dignissim. Pretium ullamcorper in habitasse nisl. Non leo pretium ut ultrices nunc malesuada augue. Eu nibh aliquam ornare ut blandit eget diam adipiscing. Dolor fringilla vulputate in sagittis mattis parturient.
					Vitae donec sed ornare dignissim nisi massa cras purus. Aliquam venenatis diam turpis ut magnis morbi. Varius interdum diam mauris sagittis quis fermentum, in sollicitudin. Adipiscing nisi ut purus massa tincidunt tempor. Sit diam velit amet varius mauris at nibh fringilla. Tincidunt nunc sit consectetur ipsum purus. A nibh turpis ligula ac vitae et.
      	</div>
      	<div className="content-button">
      		<button>Ver todos</button>
      	</div>
      </div>
    </PublicAppLayout>
  )
}

export default DescmoocsScreenLayout
